import { Button } from "@jewlr/storybook/core"
import React from "react"

import { openModal } from "components/modal"
import { isTestMode } from "helpers/application"

const InstantGiftText = () => {
  return (
    <Button
      color="primary"
      fontSize="14px"
      fontWeight="300"
      lineHeight="16px"
      mt={3}
      onClick={() => {
        openModal("#instant-gift-explained")
        if (!isTestMode) {
          dataLayer.push({
            event: "clicked-need-it-now-pdp",
          })
        }
      }}
      underline
      variant="text"
    >
      Need it now? Create an Instant Gift!
    </Button>
  )
}

export default InstantGiftText
